import $ from "jquery";

const initForm = () => {
  const $form = $("form.edit_user");
  const $table = $form.find("#preferences-table");
  const $mainTrs = $table.find("tr.main");

  $.each($mainTrs, function () {
    const $mainTr = $(this);
    const {
      collection,
    } = $mainTr.data();
    const $collectionTrs = $table.find(`tr[data-collection='${collection}']`);
    const $nonMainCollectionTrs = $collectionTrs.filter("tr:not(.main)");
    const $addButton = $mainTr.find(".add-collection-button");
    const $removeButton = $mainTr.find(".remove-collection-button");

    const $accessLevelTr = $nonMainCollectionTrs.filter(".access-levels");

    const $accessLevelOptions = $accessLevelTr.find("input.access-level-option");
    const $noneAccessLevelInput = $accessLevelOptions.filter(".none");

    const $readAccessLevelInput = $accessLevelOptions.filter(".read");
    const $editAccessLevelInput = $accessLevelOptions.filter(".edit");
    const $approveAccessLevelInput = $accessLevelOptions.filter(".approve");

    const $ownerOptions = $accessLevelTr.find(".owner-options input");

    const $notificationsTr = $nonMainCollectionTrs.filter(".notifications");
    const $notificationInputs = $notificationsTr.find("input");

    // const $allInputs = $collectionTrs.find("input");

    const toggleFormFields = () => {
      const {
        hasSubscription,
      } = $mainTr.data();

      const isOwner = $accessLevelOptions.filter(".owner").is(":checked");

      if (hasSubscription ) {
        $nonMainCollectionTrs.removeClass("hidden");

        if ($noneAccessLevelInput.prop("checked")) {
          $readAccessLevelInput.prop("checked", true);
          $noneAccessLevelInput.prop("checked", false);
        }

        $addButton.addClass("hidden");
        $removeButton.removeClass("hidden");
      } else {
        $nonMainCollectionTrs.addClass("hidden");

        $addButton.removeClass("hidden");
        $removeButton.addClass("hidden");

        $noneAccessLevelInput.prop("checked", true);
        $readAccessLevelInput.prop("checked", false);
        $editAccessLevelInput.prop("checked", false);
        $approveAccessLevelInput.prop("checked", false);
        $ownerOptions.prop("checked", false);
        $notificationInputs.prop("checked", false);
      }

      if (isOwner) {
        $ownerOptions.prop("disabled", false);
      } else {
        $ownerOptions.prop("checked", false).change();
        $ownerOptions.prop("disabled", true);
      }
    };

    $addButton.click((e) => {
      e.preventDefault();
      e.stopPropagation();

      if ($addButton.attr("disabled")) {
        return;
      }

      $mainTr.data("has-subscription", true);

      toggleFormFields();
    });

    $removeButton.click((e) => {
      e.preventDefault();
      e.stopPropagation();

      if ($addButton.attr("disabled")) {
        return;
      }

      $mainTr.data("has-subscription", false);

      toggleFormFields();
    });

    $accessLevelOptions.change(toggleFormFields);

    toggleFormFields();
  });
};

$(document).on("turbolinks:load", () => {
  initForm();
});
